import { render, staticRenderFns } from "./SportsListItem.vue?vue&type=template&id=f0cb86fc&scoped=true"
import script from "./SportsListItem.vue?vue&type=script&lang=js"
export * from "./SportsListItem.vue?vue&type=script&lang=js"
import style0 from "./SportsListItem.vue?vue&type=style&index=0&id=f0cb86fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cb86fc",
  null
  
)

export default component.exports